import React, { ElementType } from "react";
import { IconType } from "react-icons/lib";
import { Button } from "components/ui/button";

interface SocialIconLinkProps {
    href: string;
    label: string;
    Icon: IconType;
}

const SocialIconLink: React.FC<SocialIconLinkProps> = ({ href, label, Icon: IconEl }) => {
    const El = IconEl as ElementType;
    return (
        <Button variant="socialIcon" size="icon" asChild>
            <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                <El aria-hidden className="h-4 w-4" />
            </a>
        </Button>
    );
};

export default SocialIconLink;
